<script setup lang="ts">
  import { useUserStore } from '@bv/stores';
  import { computed, onMounted } from 'vue';

  import ConversationUsersApi from '@/api/conversations/conversationUsers.api';

  const userStore = useUserStore();

  const status = computed(() => userStore.userDetails);

  onMounted(() => {
    ConversationUsersApi.get({}, `${userStore.userDetails?.id}`).then((res) => {
      userStore.updateUserStatus(res.data.data.lastManualStatus);
    });
  });
</script>

<template>
  <div
    class="w-full h-full rounded-full bg-gray-400"
    :class="{
      'bg-success-400': status?.userStatus === 0,
      'bg-warning-400': status?.userStatus === 1,
    }"
  />
</template>
